module.exports = __webpack_public_path__ + "static/media/slim-preto.72a2c5ee.webp";